<template>
  <h2 class="sales-funnel-subtitle">
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'Subtitle',
};
</script>

<style scoped lang="scss">
@use 'scss-vars';

.sales-funnel-subtitle {
  font-family: scss-vars.$font-bold;
  font-size: 20px;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 4px;

  @media screen and (min-width: scss-vars.$screen-lg-min) {
    margin-bottom: 8px;
  }
}
</style>
